<template>


<div class=" mx-auto mt-4 lg:mt-12">

      <DoctorAppointmentSticky></DoctorAppointmentSticky>
        
      <form @submit.prevent="submitAppointmentRequest()" class="grid grid-cols-1 mx-auto gap-x-8 gap-y-6 sm:grid-cols-2">
        <div class="sm:col-span-2">
          <label for="first-time-pt" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            这是否是您首次于{{ doctorDetails.provider.cn_name }}医师诊所就诊？
          </label>
          
          <span class="isolate inline-flex rounded-md shadow-sm">
            <!-- PT: {{ ptData.pt_is_first_visit }} -->
            <button @click="ptData.pt_is_first_visit=true" type="button" class="relative inline-flex items-center rounded-l-md  px-3 py-2 ring-1 ring-inset ring-gray-300  text-xs focus:z-10" :class="ptData.pt_is_first_visit? 'font-bold hover:bg-primaryBtnHoverHover bg-primaryBtnHover text-white border border-primaryBtnHover ring-primaryBtnHover': 'hover:bg-gray-50 bg-white text-gray-900'">是，第一次在此诊所问诊</button>
            <button @click="ptData.pt_is_first_visit=false" type="button" class="relative inline-flex items-center rounded-r-md px-3 py-2 ring-1 ring-inset ring-gray-300  text-xs focus:z-10" :class="!ptData.pt_is_first_visit? 'font-bold hover:bg-primaryBtnHoverHover bg-primaryBtnHover text-white border border-primaryBtnHover ring-primaryBtnHover': 'hover:bg-gray-50 bg-white text-gray-900'" >否，我以前有来过此诊所问诊</button>
           </span>
        </div>

        <div class="sm:col-span-2">
          <label for="anonymous_visit" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            是否希望匿名就诊 <button type="button" data-popover-target="country-description" class="w-4 h-4">
              <svg aria-hidden="true" class="text-gray-400 hover:text-gray-900 dark:hover:text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                fill="currentColor">
                <path fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                  clip-rule="evenodd" />
              </svg>
              <span class="sr-only">显示详细信息</span>
            </button>
            <div data-popover id="country-description" role="tooltip" class="absolute z-10 invisible inline-block text-sm font-light text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-0 w-72 dark:bg-gray-800 dark:border-gray-600 dark:text-gray-400">
                <div class="p-3 space-y-2">
                    <h3 class="font-semibold text-gray-900 dark:text-white">匿名就诊</h3>
                    <p>为了能够进一步保护您的隐私和数据安全，并鼓励患者与医生建立信任以真实、完整、无拘束的方式沟通自身情况，平台可协助患者与部分合作诊所安排匿名会诊，平台将为您随机生成化名身份, 您只需向平台提供基本联系方式（可使用虚拟号码），无需真实提供姓名，生日等敏感个人信息方可完进行就诊。但请您注意，绝大部分医疗保险需要您的真实身份信息才可为您提供医疗保障，使用匿名就诊方式可能意味着您需要自行承担问诊和相关费用。如需进一步帮助，您可联系平台客服或直接联系诊所</p>
                    
                    
                    <!-- <a href="#" class="flex items-center font-medium text-primary-600 dark:text-primary-500 dark:hover:text-primary-600 hover:text-primary-700">Read more <svg class="w-4 h-4 ml-1" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg></a> -->
                </div>
                <div data-popper-arrow></div>
            </div>
          </label>
          <span class="isolate inline-flex rounded-md shadow-sm">
            <button @click="ptData.pt_is_anonymous_visit=true, ptData.pt_use_medical_insurance=false, ptData.pt_try_different_provider=false" type="button" class="relative inline-flex items-center rounded-l-md  px-3 py-2 ring-1 ring-inset ring-gray-300  text-xs focus:z-10" :class="ptData.pt_is_anonymous_visit? 'font-bold hover:bg-primaryBtnHoverHover bg-primaryBtnHover text-white border border-primaryBtnHover ring-primaryBtnHover': 'hover:bg-gray-50 bg-white text-gray-900'">是，我希望进行匿名就诊</button>
            <button @click="ptData.pt_is_anonymous_visit=false" type="button" class="relative inline-flex items-center rounded-r-md  px-3 py-2 ring-1 ring-inset ring-gray-300  text-xs focus:z-10" :class="!ptData.pt_is_anonymous_visit? 'font-bold hover:bg-primaryBtnHoverHover bg-primaryBtnHover text-white border border-primaryBtnHover ring-primaryBtnHover': 'hover:bg-gray-50 bg-white text-gray-900'" >否，不需要匿名就诊</button>
           </span>
        </div>

        <div class="sm:col-span-2">
          <div class="flex p-4 mb-4 text-sm text-blue-800 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400" role="alert">
  <svg aria-hidden="true" class="flex-shrink-0 inline w-5 h-5 mr-3" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>
  <span class="sr-only">Info</span>
  <div>
    <span class="font-medium"></span> 为了能够进一步保护您的隐私和数据安全，并鼓励患者与医生建立信任以真实、完整、无拘束的方式沟通自身情况，平台可协助患者与部分合作诊所安排匿名会诊，平台将为您随机生成化名身份, 您只需向平台提供基本联系方式（可使用虚拟号码），无需真实提供姓名，生日等敏感个人信息方可完进行就诊。但请您注意，绝大部分医疗保险需要您的真实身份信息才可为您提供医疗保障，使用匿名就诊方式可能意味着您需要自行承担问诊和相关费用。如需进一步帮助，您可联系平台客服或直接联系诊所

    <!-- <div>
                     {{ ptData }} 
         </div> -->
  </div>
</div>
        </div>

        

        <div>
          <label for="name" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            您的姓名
          </label>
          <input v-model="ptData.pt_name" type="text" id="name"
            class="block w-full p-3 text-sm text-gray-900 border border-gray-300 rounded-lg shadow-sm bg-gray-50 focus:bg-primaryBtnHoverHoverLite/30 focus:border-white"
            :class="ptData.pt_is_anonymous_visit? 'bg-gray-400':''" 
            :placeholder="ptData.pt_is_anonymous_visit? '匿名就诊 - 无需填写' :'英文，简繁体均可，如：川建国 或 Jianguo Chuan'" :disabled="ptData.pt_is_anonymous_visit">
        </div>

        <div>
          <label for="dob" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            您的生日 {{ ptData.pt_is_anonymous_visit? '(无需填写)':'' }}
          </label>
          <input v-model="ptData.pt_dob" type="date" id="dob"
            class="block w-full p-3 text-sm text-gray-900 border border-gray-300 rounded-lg shadow-sm bg-gray-50 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
            :class="ptData.pt_is_anonymous_visit? 'bg-gray-400':''" 
            :disabled="ptData.pt_is_anonymous_visit"
            >
        </div>

        <div>
          <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            您的电子邮件 (选填)
          </label>
          <input v-model="ptData.pt_email" type="email" id="email"
            class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
            placeholder="如: chuanjianguo@gmail.com">
        </div>

        <div>
          <label for="phone-number" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            您的电话号码
          </label>
          <input v-model="ptData.pt_phone" type="text" id="phone-number"
            class="block w-full p-3 text-sm text-gray-900 border border-gray-300 rounded-lg shadow-sm bg-gray-50 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
            placeholder="+17183456789" required>
        </div>

        

        <div>
          <div class="flex items-center gap-1.5 mb-2">
            <label for="country" class="block text-sm font-medium text-gray-900 dark:text-gray-300">
              您的本次预约就诊{{ doctorDetails.provider.cn_name }}医师目的
            </label>
            <button type="button" data-popover-target="purpose-list" class="w-4 h-4">
              <svg aria-hidden="true" class="text-gray-400 hover:text-gray-900 dark:hover:text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                fill="currentColor">
                <path fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                  clip-rule="evenodd" />
              </svg>
              <span class="sr-only">Show information</span>
            </button>
            <div data-popover id="purpose-list" role="tooltip" class="absolute z-10 invisible inline-block text-sm font-light text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-0 w-72 dark:bg-gray-800 dark:border-gray-600 dark:text-gray-400">
                <div class="p-3 space-y-2">
                    <h3 class="font-semibold text-gray-900 dark:text-white">一般问诊或咨询</h3>
                    <p>如您是首次就诊，需要转诊，需要开新药或有新的症状，建议选择 “一般问诊或咨询”</p>
                    <h3 class="font-semibold text-gray-900 dark:text-white">诊断回访或查看报告</h3>
                    <p>如您需要与医生同步诊断进度，如查看报告，处方药继药等建议选择 “诊断回访或查看报告”</p>
                    <h3 class="font-semibold text-gray-900 dark:text-white">其他</h3>
                    <p>其他事宜，请在下方注明</p>
                    <!-- <a href="#" class="flex items-center font-medium text-primary-600 dark:text-primary-500 dark:hover:text-primary-600 hover:text-primary-700">Read more <svg class="w-4 h-4 ml-1" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg></a> -->
                </div>
                <div data-popper-arrow></div>
            </div>
          </div>
          <select v-model="ptData.pt_visit_reason" id="country"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500">
            <option value="unselected" selected>请在下拉菜单中选择</option>
            <option value="general-consulting" >一般问诊或咨询</option>
            <option value="follow-up" >诊断回访或查看报告</option>
            <option value="remote-visit" >远程就诊，处方药配送到家</option>
            <option value="other" >其他 （请在下方注明）</option>
          </select>
        </div>
        
        <div>
          <div class="flex items-center gap-1.5 mb-2">
            <label for="language-preference" class="block text-sm font-medium text-gray-900 dark:text-gray-300">
              您的语言和方言偏好
            </label>
            <button type="button" data-popover-target="language-description" class="w-4 h-4">
              <svg aria-hidden="true" class="text-gray-400 hover:text-gray-900 dark:hover:text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                fill="currentColor">
                <path fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                  clip-rule="evenodd" />
              </svg>
              <span class="sr-only">Show information</span>
            </button>
            <div data-popover id="language-description" role="tooltip" class="absolute z-10 invisible inline-block text-sm font-light text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-0 w-72 dark:bg-gray-800 dark:border-gray-600 dark:text-gray-400">
                <div class="p-3 space-y-2">
                    <h3 class="font-semibold text-gray-900 dark:text-white">您的语言和方言偏好</h3>
                    <p>如您有方言偏好，或与就诊医师或诊所沟通困难，如有资源允许，北美好医生平台客服人员将尽力协助您与您的诊所或医生进行沟通</p>
                    
                </div>
                <div data-popper-arrow></div>
            </div>
          </div>
          
          <select v-model="ptData.pt_language_preference" id="language"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500">
            <option value="unselected" selected>无偏好</option>
            <option value="Zh-Mandarin">中文-普通话</option>
            <option value="En-US" >英文-英语</option>
            <option value="Zh-Cantonese">中文-广东话</option>
            <!-- <option value="Zh-Shanghainese">中文-上海话</option> -->
            <option value="Zh-Minnan">中文-闽南语</option>
            <option value="Zh-Sign">中文-手语-TTY</option>
            <option value="En-Sign">英文-手语-TTY</option>
            
          </select>
        </div>

        <div>
          <label for="use-medical-insurance" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            本次与{{ doctorDetails.provider.cn_name }}医师就诊是否需要使用您的医疗保险？
          </label>
          
          <span class="isolate inline-flex rounded-md shadow-sm">
            <button @click="ptData.pt_use_medical_insurance=true" type="button" class="relative inline-flex items-center rounded-l-md  px-3 py-2 ring-1 ring-inset ring-gray-300  text-xs focus:z-10" :class="ptData.pt_use_medical_insurance? 'font-bold hover:bg-primaryBtnHoverHover bg-primaryBtnHover text-gray-200': 'hover:bg-gray-50 bg-white text-gray-900'" :disabled="ptData.pt_is_anonymous_visit" >{{ ptData.pt_is_anonymous_visit?"匿名就诊-可能无法使用保险":"是，我希望使用我的医疗保险" }}</button>
            <button @click="ptData.pt_use_medical_insurance=false" type="button" class="relative inline-flex items-center rounded-r-md  px-3 py-2 ring-1 ring-inset ring-gray-300  text-xs focus:z-10" :class="!ptData.pt_use_medical_insurance? 'font-bold hover:bg-primaryBtnHoverHover bg-primaryBtnHover text-gray-200': 'hover:bg-gray-50 bg-white text-gray-900'">否，我希望自费就诊</button>
           </span>
        </div>

        <div>
          <label for="first-time-pt" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            如{{ doctorDetails.provider.cn_name }}医师无法接受您的保险，您是否希望平台帮您寻找其他诊所？
          </label>
          
          <span class="isolate inline-flex rounded-md shadow-sm">
            <button @click="ptData.pt_try_different_provider=true" type="button" class="relative inline-flex items-center rounded-l-md  px-3 py-2 ring-1 ring-inset ring-gray-300  text-xs focus:z-10" :class="ptData.pt_try_different_provider? 'font-bold hover:bg-primaryBtnHoverHover bg-primaryBtnHover text-gray-200': 'hover:bg-gray-50 bg-white text-gray-900'" :disabled="ptData.pt_is_anonymous_visit"> {{ ptData.pt_is_anonymous_visit?"匿名就诊-可能无法使用保险":"好，帮我找可以收我保险的诊所" }}</button>
            <button @click="ptData.pt_try_different_provider=false" type="button" class="relative inline-flex items-center rounded-r-md  px-3 py-2 ring-1 ring-inset ring-gray-300  text-xs focus:z-10" :class="!ptData.pt_try_different_provider? 'font-bold hover:bg-primaryBtnHoverHover bg-primaryBtnHover text-gray-200': 'hover:bg-gray-50 bg-white text-gray-900'">否，我希望自费就诊</button>
           </span>
        </div>
        <div>
          <label for="insurance-company-name" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            您的医疗保险公司名称
          </label>
          <input v-model="ptData.pt_insurance_company_name" type="text" id="insurance-company-name"
            class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
            :class="ptData.pt_is_anonymous_visit || !ptData.pt_use_medical_insurance? 'bg-gray-400':''" 
            :placeholder="ptData.pt_is_anonymous_visit || !ptData.pt_use_medical_insurance? '无需填写' :'可在保险卡上找到，中英文均可'" :disabled="ptData.pt_is_anonymous_visit || !ptData.pt_use_medical_insurance">
        </div>

        <div>
          <label for="insurance-member-id" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            保险会员号码
          </label>
          <input v-model="ptData.pt_insurance_member_id" type="text" id="insurance-member-id"
            class="block w-full p-3 text-sm text-gray-900 border border-gray-300 rounded-lg shadow-sm bg-gray-50 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
            
            :class="ptData.pt_is_anonymous_visit || !ptData.pt_use_medical_insurance? 'bg-gray-400':''" 
            :placeholder="ptData.pt_is_anonymous_visit || !ptData.pt_use_medical_insurance? '无需填写' :'位于您保险卡上，如自费或找不到可不填'" :disabled="ptData.pt_is_anonymous_visit || !ptData.pt_use_medical_insurance">
        </div>

        <div class="sm:col-span-2">
          <label for="message" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400">
            其他需求（选填，请不要填写受保护的敏感信息）
            <p class="text-red-500">北美好医生不能替代紧急医疗服务，紧急情况，请立即拨打911</p>
          </label>
          <textarea v-model="ptData.pt_other_request" id="message" rows="6"
            class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg shadow-sm border border-gray-300 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
            placeholder="可填写您的具体需求，以便平台和诊所进行安排，请避免填写具体病情或敏感个人信息"></textarea>
        </div>
        
        <div class="flex items-center pl-4 border border-gray-200 rounded dark:border-gray-700">
            <input v-model="ptData.pt_email_sms_consent" id="bordered-checkbox-1" type="checkbox" value="" name="bordered-checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
            <label for="bordered-checkbox-1" class="w-full py-4 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">请通过邮件或手机短信通知我预约相关信息</label>
        </div>

        <div class="flex items-center pl-4 border border-gray-200 rounded dark:border-gray-700">
            <input v-model="ptData.pt_save_info"  checked id="bordered-checkbox-2" type="checkbox" value="" name="bordered-checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
            <label for="bordered-checkbox-2" class="w-full py-4 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">请保存我的信息，以便下次就诊使用</label>
        </div>

        <div class="sm:col-span-2">
          <div class="flex items-start">
            <input v-model="ptData.pt_term_accepted" type="checkbox" id="terms" value=""
              class="w-4 h-4 text-primary-600 bg-gray-100 border-gray-300 rounded focus:ring-primary-500 dark:focus:ring-primary-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
            <label for="terms" class="ml-2 text-sm font-normal text-gray-500 dark:text-gray-400">
              我已阅读、理解并同意上方免责声明以及北美好医生的
              <a href="/policy/tou" title="" class="font-medium text-gray-900 hover:no-underline underline dark:text-white">
                《用户协议》（英文）
              </a>
              和
              <a href="/policy/privacy" title="" class="font-medium text-gray-900 hover:no-underline underline dark:text-white">
                《隐私政策》(英文)
              </a>.
            </label>
          </div>
        </div>

        <button type="submit"
          class="px-5 py-3 text-sm font-medium text-center text-white rounded-lg bg-primary-700 sm:w-fit hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">提交预约请求</button>
      </form>
  <!-- <a v-if="doctorDetails.provider.tier === 'tier3' || doctorDetails.provider.tier === 'tier4'" :href="`tel:${doctorDetails.provider.telephone}`" class="relative inline-flex w-0 flex-1 items-center justify-center gap-x-3 border border-transparent py-4 text-sm font-semibold text-primaryText hover:text-primaryBtnHover hover:bg-primaryBtnHoverLite">
    <PhoneIcon class="h-5 w-5 text-primaryColor/70" aria-hidden="true" />
    24小时客服
  </a> -->
</div>
</template>


<script setup>
import {PhoneIcon} from "@heroicons/vue/20/solid/index.js";

const {doctorDetails} = useSearch()
const {targetDoctorId, targetFacilityId, targetDateTime, ptData, submitAppointmentRequest } = usePatientAppointmentRequest()


</script>